// @flow strict-local

import type {State} from 'src/reducers';


export const selectReleaseFlags = (state: State): {[string]: boolean} =>
  state.productFlags.releaseFlags;
